var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_vm._v(" "+_vm._s(_vm.$t('labels.loginyou'))+"... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }